import React, { Component } from 'react';
import { Modal, Button, Tabs, Tab, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import TermsInfo from './TermsInfo';
import * as actionCreator from "../../action/quote_order/leadcustomer.action.js";

class TermsCondition extends React.Component {

   constructor(props) {
  super(props);
  
}

render() {

    //console.log(this.props.displayerrorMessage,this.props.checkLeadCustomerValidate,cross);
      return (
         <div>
      
            <Modal centered show={this.props.showTermsCondition} backdrop='static' keyboard={false} onHide={(e)=>this.props.handleCommonModal('close')}  dialogClassName='terms-condition-modal react-modal alert-modal' backdropClassName="ract-modal-pre-parent" >
            <button className="close" onClick={(e)=>this.props.handleCommonModal('close')}><span className="icon-close"></span></button>
                   <Modal.Body>
                      <div className='row'>

                         <div className='col-12'>
                         <h5 class="modal-title modal-title-left text-uppercase mb-4">Disclaimer</h5>
                         </div>
                         </div>               
                <TermsInfo/>
               </Modal.Body>
            </Modal>
            
         </div>
      )
   }
}
const mapStateToProps = (state) => {
   return state.leadcustomerReducer
}


export default connect(
   mapStateToProps,
   actionCreator
)(TermsCondition);
